import { WidgetInitializer } from "../functions/widget-initializer";
import { ConfigUtils } from "../functions/config-utils";
import { LocalStorageUtils } from "../functions/local-storage-utils";
import { Constants } from "../functions/constants";

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.BRANCH_CTA);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.BRANCH_CTA, function () {
    widgetInitializer.initialize(initBranchCtaApp);
});

function initBranchCtaApp(element) {

    var config = ConfigUtils.getConfigFor(element);

    var vueApp = new Vue({
        el: '#' + element.id,
        data: {
            equipmentTypes: [],
            searchTerm: '',
            searchRadius: Constants.LOCAL_STORAGE.DEFAULT_RADIUS
        },
        computed: {
            type_filters: function type_filters() {
                return config.model.EquipmentTypes;
            },
            radius_options: function radius_options() {
                return config.model.RadiusOptions;
            }
        },
        methods: {
            search: function goToLocations() {
                LocalStorageUtils.updateLocalStorageData(otherPreferences => {
                    otherPreferences.searchRadius = this.searchRadius;
                    otherPreferences.searchTerm = this.searchTerm;
                    otherPreferences.equipmentTypes = this.equipmentTypes;
                });

                window.location.href = config.model.BranchFinderLink.LinkUrl;
            }
        },
        created: function () {
            var stored_data = LocalStorageUtils.getLocalStorageData();
            this.searchRadius = stored_data.searchRadius;
            this.searchTerm = stored_data.searchTerm;
            this.equipmentTypes = stored_data.equipmentTypes;
        }
    });

    return vueApp.$el;
}